<template>
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :append-to-body='true'>
      <div class="main-box">
          <div class="ewm">
            <img src="../../assets/img/qr_code.png"/>
          </div>
          <div class="pay-div">支付金额：{{temp.comboMoney}}元</div>
      </div>
    </el-dialog>

</template>

<script>
    export default {
      name: "CompanyInfo",
      data() {
        return {
          dialogName: '购买',
          dialogVisible: false,                                        //弹框
          isComboBuyShow: false,                                        //弹框
          temp: {
            comboMoney :'',
          },
          rules: []
        }
      },
      computed: {
        orgCategory() {
          return this.$store.getters.orgCategory; //获取机构类型
        },
        orgId() {
          return this.$store.getters.orgId; //获取机构id
        },
        orgName() {
          return this.$store.getters.orgName; //获取机构名称
        },
      },
      components: {

      },
      methods: {
        init(comboMoney){
          this.dialogVisible = true;
          this.temp.comboMoney = comboMoney;
        },
        buy(){
          this.isComboBuyShow = true;
          this.$nextTick(()=>{
            this.$refs.comboBuy.init() //初始化页面
          })
        }
      }
    }
</script>

<style scoped>
  .about-title{position: relative;}
  .about-title .about-font{
    position: absolute;
    color: #fff;
    top: 33%;
    left: 26%;
    font-size: 33px;
    font-weight: 600;
  }
  .about-title img{width: 100%;}

  .ewm{
    text-align: center;
  }
  .ewm img{
    width: 300px;
  }

  .pay-div{
    text-align: center;
    margin: 40px;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/header/Pay-Info.vue